import React from 'react';

import { FaCheckCircle, FaExclamationCircle, FaQuestionCircle } from 'react-icons/fa';

export interface CompilanceIconsProps {
	compliance: string;
}

export enum CompilanceIconResolution {
	accept = 'accept',
	acceptNoRulesForDataSource = 'accept-no-rules-for-data-source',
	acceptWithWarning = 'accept-with-warning',
	acceptBeforeValidity = 'accept-before-validity',
	cannotInterpretRules = 'cannot-interpret-rules',
	reject = 'reject',
	rejectNoPrices = 'reject-no-prices',
	rejectNotAReferenceDataSource = 'reject-not-a-reference-data-source',
	rejectRemoved = 'reject-removed',
	rejectAfterValidity = 'reject-after-validity',
}

function categoryIcons(type: string) {
	if (type === CompilanceIconResolution.accept || type === CompilanceIconResolution.acceptNoRulesForDataSource) {
		return <FaCheckCircle className='w-4 h-4 text-green-600' />;
	}
	if (
		type === CompilanceIconResolution.reject ||
		type === CompilanceIconResolution.rejectNoPrices ||
		type === CompilanceIconResolution.rejectNotAReferenceDataSource ||
		type === CompilanceIconResolution.rejectRemoved ||
		type === CompilanceIconResolution.rejectAfterValidity
	) {
		return <FaExclamationCircle className='w-4 h-4 text-red-600' />;
	}
	return <FaQuestionCircle className='w-4 h-4 text-yellow-600' />;
}

export function CompilanceIcons({ compliance }: CompilanceIconsProps) {
	return <>{categoryIcons(compliance)}</>;
}
